import React from "react";
import { BrowserRouter } from "react-router-dom";
import { PublicClientApplication } from "@azure/msal-browser";

import AppContent from "../containers/AppContent";
import ErrorBoundary from "./ErrorBoundary";

export interface PropsFromState {
  instance: PublicClientApplication;
}
type AllProps = PropsFromState;

const App: React.FC<AllProps> = ({ instance }) => {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AppContent instance={instance} />
      </BrowserRouter>
    </ErrorBoundary>
  );
};

export default App;